import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  id: "i1489763939__Layer_2",
  "data-name": "Layer 2",
  viewBox: "0 0 34.91 34.91"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("defs", null, [
      (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode(".i1489763939__cls-2{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:.82px}")
        ])),
        _: 1
      }))
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("g", {
      id: "i1489763939__Lager_2",
      "data-name": "Lager 2"
    }, [
      _createElementVNode("circle", {
        cx: "17.46",
        cy: "17.46",
        r: "17.46",
        style: {"fill":"#0a1e3f","opacity":"1"}
      }),
      _createElementVNode("path", {
        d: "m18.39 10.74 6.42 6.42-6.37 6.38M7.69 17.16H24.1",
        class: "i1489763939__cls-2"
      })
    ], -1))
  ]))
}
export default { render: render }